import onOutOfView from 'core/DOM/onOutOfView'

function setPlanOutOfViewHandler() {
  let lastResult = false

  onOutOfView('js-plan-info', function onOutOfViewHandler({ isOutOfView }) {
    if (lastResult !== isOutOfView) {
      lastResult = isOutOfView
      document.body.classList.toggle('plan--sticky')
    }
  })
}

export default setPlanOutOfViewHandler
